<template>
  <div>
    <div class="wrapper">
      <section class="banner first-section-space">
        <div class="os-main-banner">
          <div class="container">
            <div class="row">
              <div class="banner-heading col-lg-6">
                <h1>
                  KIPS Online School
                  <span class="break-after">opens the door to <span class="blue-text">limitless</span></span>
                  learning!
                </h1>
                <p>Where every lesson inspires, every click empowers, and every student is prepared for a brighter, more confident future. We’re shaping tomorrow through a learning experience designed to inspire, uplift, and transform lives.</p>
                <button class="purple-btn btn-margin" @click="openBookDemoPopup()">Book a Demo</button>
              </div>

              <div class="col-lg-6">
                <SsrCarousel
                  :autoplay-delay="3"
                  loop
                  :slides-per-page="1"
                  :responsive="[
                    { maxWidth: 1024, slidesPerPage: 1 },
                    { maxWidth: 600, slidesPerPage: 1 },
                  ]"
                >
                  <div class="slide" :index="1">
                    <div class="banner-img">
                      <img src="/assets/images/os-images/banner-img1.png" alt="Main-Banner-Image" width="819" height="816" />
                    </div>
                  </div>

                  <div class="slide" :index="2">
                    <div class="banner-img">
                      <img src="/assets/images/os-images/banner-img2.png" alt="Main-Banner-Image" width="819" height="816" />
                    </div>
                  </div>

                  <div class="slide" :index="3">
                    <div class="banner-img">
                      <img src="/assets/images/os-images/banner-img3.png" alt="Main-Banner-Image" width="819" height="816" />
                    </div>
                  </div>

                  <div class="slide" :index="4">
                    <div class="banner-img">
                      <img src="/assets/images/os-images/banner-img4.png" alt="Main-Banner-Image" width="819" height="816" />
                    </div>
                  </div>

                  <div class="slide" :index="5">
                    <div class="banner-img">
                      <img src="/assets/images/os-images/banner-img5.png" alt="Main-Banner-Image" width="819" height="816" />
                    </div>
                  </div>
                </SsrCarousel>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="our-focus" class="our-focus s-section-space">
        <div class="container">
          <div class="row">
            <div class="our-focus-div col-sm-12">
              <div class="our-focus-text">
                <h3>Our Focus</h3>
                <p>KIPS Online School focuses on delivering accessible, quality education to empower learners and build a better world and brighter future.</p>
              </div>
              <!-- <div class="our-focus-img">
                <img src="/assets/images/os-images/our-focus-img.png" alt="" width="283" height="136" />
              </div> -->

              <div class="our-focus-boxes mission col-sm-12">
                <div class="img-text">
                  <img src="/assets/images/os-images/mission-img.png" alt="" width="56" height="56" />
                  <h3>Mission</h3>
                </div>
                <p>To provide high-quality, flexible, and engaging online education that nurtures academic excellence, critical thinking, and lifelong learning, empowering students to succeed in a dynamic world.</p>
              </div>
              <div class="our-focus-boxes vision col-sm-12">
                <div class="img-text">
                  <img src="/assets/images/os-images/vision.png" alt="" width="56" height="56" />
                  <h3>Vision</h3>
                </div>
                <p>Transforming lives through accessible quality education for better world & brighter future.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="kips-grades" class="school-grades school-grade-home section-space">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="grade-img-div">
                <img src="/assets/images/os-images/school-grade-img1.png" alt="" width="773" height="749" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="grade-text-div">
                <div class="headings">
                  <h2>KIPS Online School <span class="grade-text">Grades</span></h2>
                </div>
                <div class="education-lvl" v-if="categoriesData">
                  <div class="category" v-for="(item, index) in categoriesData.categories" :key="index">
                    <div @click="goToCategoryDetail(item)" :class="item.isLinkAble ? 'pointer' : 'not-available'">
                      <span>{{ item.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="school-activity" class="school-activity section-space">
        <div class="activityWrapper">
          <div class="container">
            <div class="headings">
              <h2>School Activity</h2>
            </div>
            <div class="activitySliderWrapepr">
              <!-- Main Content Slider -->
              <div class="activityContent">
                <VueSlickCarousel ref="activityContent" v-bind="contentSettings" :key="'content-slider'">
                  <div v-for="(item, index) in activities" :key="index">
                    <div class="activityContentCell">
                      <h4>{{ item.title }}</h4>
                      <p>{{ item.description }}</p>
                    </div>
                  </div>
                </VueSlickCarousel>
              </div>

              <!-- Thumbnail Slider -->
              <div class="activityImg">
                <VueSlickCarousel ref="activityImg" v-bind="thumbnailSettings" :key="'thumbnail-slider'">
                  <div v-for="(item, index) in activities" :key="index">
                    <div class="activityImgCell">
                      <img :src="item.imgSrc" alt="Activity Image" width="56" height="56" />
                    </div>
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- <section id="testimonials" class="hear-about section-space">
        <div class="container">
          <div class="">
            <div class="headings col-12">
              <h2>Hear <span class="about-text">About</span> Us</h2>
            </div>
            <div>
              <b-card no-body>
                <b-tabs card>
                  <b-tab no-body title="Listen From Us">
                    <b-card class="custom-card">
                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-one.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-two.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-three.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-four.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>
                    </b-card>
                  </b-tab>

                  
                  <b-tab no-body title="Student Voices">
                    <b-card class="custom-card">
                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-three.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-two.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-one.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-four.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>
                    </b-card>
                  </b-tab>

                 
                  <b-tab no-body title="Parental Impressions">
                    <b-card class="custom-card">
                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-four.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-three.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-one.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-two.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>
                    </b-card>
                  </b-tab>

                 
                  <b-tab no-body title="Testimonials">
                    <b-card class="custom-card">
                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-two.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-three.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-four.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>

                      <div class="single-thumb">
                        <div class="image-container">
                          <img
                            src="/assets/images/os-images/listen-one.png"
                            alt="Video 1"
                            width="480"
                            height="328"
                          />
                          <div class="play-icon">
                            <img
                              src="/assets/images/os-images/play-icon.png"
                              alt="Video 1"
                              width="60"
                              height="60"
                            />
                          </div>
                        </div>
                        <b-card-body>
                          <b-card-title>Lorem Ipsum Dolor</b-card-title>
                          <b-card-text>
                            Lorem ipsum dolor sit amet consectetur. Volutpat volutpat
                            tempus erat maecenas congue nam in. Orci euismod non turpis
                            sapien. Lorem ipsum dolor sit amet consectetur.
                          </b-card-text>
                        </b-card-body>
                      </div>
                    </b-card>
                  </b-tab>
                </b-tabs>
              </b-card>
            </div>
          </div>
        </div>
      </section> -->

      <section id="hearaboutus" class="hear-about section-space">
        <div class="container">
          <div class="">
            <div class="headings col-12">
              <h2>Hear <span class="about-text">About</span> Us</h2>
            </div>
            <div>
              <b-card no-body>
                <b-tabs card>
                  <!-- Get to Know -->

                  <b-tab no-body title="Get to Know">
                    <b-card class="custom-card">
                      <SsrCarousel
                        loop
                        :slides-per-page="4"
                        :autoplay="true"
                        :itemsToScroll="1"
                        :paginate-by-slide="true"
                        :autoplaySpeed="2000"
                        show-dots
                        :responsive="[
                          { maxWidth: 1400, slidesPerPage: 3, itemsToScroll: 1 },
                          { maxWidth: 992, slidesPerPage: 2, itemsToScroll: 1 },
                          { maxWidth: 576, slidesPerPage: 1, itemsToScroll: 1 },
                        ]"
                      >
                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/getto-know1.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/pKOgyTiR434')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>Introductory video </b-card-title>
                            <b-card-text>KIPS Online School — a smart, flexible, and structured digital learning platform designed for students across Pakistan and beyond.</b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/getto-know2.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/dpn5olmrdkI')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>Principal’s Message </b-card-title>
                            <b-card-text>Principal of KIPS Online School, warmly introduces himself and welcomes students and parents to this exciting new digital learning platform.</b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/getto-know3.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/WCMBnPizhlE')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>I’m excited to join KIPS Online School!</b-card-title>
                            <b-card-text>A future student shares their voice and trust in the upcoming KIPS Online School — where smart, flexible, and quality learning is just a click away!</b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/getto-know4.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/rT3Xa8YkeqE')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>I’m ready for smart learning at KIPS Online School!</b-card-title>
                            <b-card-text>This future student shares their trust in the upcoming KIPS Online School — believing it will bring quality, flexible, and engaging learning right to their screen.</b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/getto-know5.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/P5H_tD98tao')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>I’m confident KIPS Online School will offer the best online learning!</b-card-title>
                            <b-card-text>This student shares their trust and enthusiasm for the upcoming KIPS Online School — a new way to learn smarter, safer, and better from anywhere.</b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/getto-know6.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/8l5RKrOJxgQ')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>I know KIPS will deliver a great online experience!</b-card-title>
                            <b-card-text>This student shares their expectations from the soon-to-be-launched KIPS Online School — a smart and trusted platform for digital learning in Pakistan.</b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/getto-know7.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/2kVGtd5YHPQ')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>

                          <b-card-body>
                            <b-card-title>I believe KIPS Online School will make learning better and easier!</b-card-title>
                            <b-card-text>Watch this student share their trust and excitement for the upcoming KIPS Online School — where quality meets convenience in a digital classroom.</b-card-text>
                          </b-card-body>
                        </div>
                      </SsrCarousel>
                    </b-card>
                  </b-tab>

                  <!-- Student Voices -->
                  <b-tab no-body title="Student Voices">
                    <b-card class="custom-card">
                      <SsrCarousel
                        loop
                        :slides-per-page="4"
                        :autoplay="true"
                        :itemsToScroll="1"
                        :paginate-by-slide="true"
                        :autoplaySpeed="2000"
                        show-dots
                        :responsive="[
                          { maxWidth: 1400, slidesPerPage: 3, itemsToScroll: 1 },
                          { maxWidth: 992, slidesPerPage: 2, itemsToScroll: 1 },
                          { maxWidth: 576, slidesPerPage: 1, itemsToScroll: 1 },
                        ]"
                      >
                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/student-voice1.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/nkCXlM8zhHQ')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>A Smart Way to Learn from Home</b-card-title>
                            <b-card-text> A student shares their excitement and expectations for KIPS Online School, even before its official launch. With interactive lessons, expert teachers, and flexible learning — KIPS is ready to redefine digital education in Pakistan. </b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/student-voice2.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/XSAZLs4oKqo')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>KIPS Online School will be just as great as their campuses!</b-card-title>
                            <b-card-text>A future student shares their confidence and excitement for the launch of KIPS Online School — a platform designed to bring smart, structured, and reliable learning to your home.</b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/student-voice3.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/Lzl9mJ2JAbc')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>Even before the launch, I believe in KIPS Online School!</b-card-title>
                            <b-card-text>This student shares their trust and excitement for the upcoming KIPS Online School — where high-quality education meets the flexibility of digital learning.</b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/student-voice4.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/MhqZcImI5Y8')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>KIPS Online School will make learning easy and effective!</b-card-title>
                            <b-card-text>In this video, a student shares their excitement and trust in the upcoming KIPS Online School. With live classes, expert teachers, and a smart learning system — students are already eager for what’s coming. </b-card-text>
                          </b-card-body>
                        </div>
                      </SsrCarousel>
                    </b-card>
                  </b-tab>

                  <!-- Parental Impressions -->
                  <b-tab no-body title="Parental Impressions">
                    <b-card class="custom-card">
                      <SsrCarousel
                        loop
                        :slides-per-page="4"
                        :autoplay="true"
                        :itemsToScroll="1"
                        :paginate-by-slide="true"
                        :autoplaySpeed="2000"
                        show-dots
                        :responsive="[
                          { maxWidth: 1400, slidesPerPage: 3, itemsToScroll: 1 },
                          { maxWidth: 992, slidesPerPage: 2, itemsToScroll: 1 },
                          { maxWidth: 576, slidesPerPage: 1, itemsToScroll: 1 },
                        ]"
                      >
                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/parental-impression1.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/ypJdwQlS1Bg')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>Even before its launch, I’m confident in KIPS Online School!</b-card-title>
                            <b-card-text> In this video, a future student shares their thoughts, excitement, and trust in the upcoming KIPS Online School. With a legacy of excellence, KIPS is now stepping into digital education — and students are ready! </b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/parental-impression2.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/otAZwFT9Cr4')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>I’m confident that KIPS Online School will provide quality education from the comfort of home.</b-card-title>
                            <b-card-text>In this video, a parent shares their thoughts and confidence in the upcoming KIPS Online School. Known for its excellence in education, KIPS is now stepping into the digital learning world — and parents are already on board! </b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/parental-impression3.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/0cX2TY7vWyg')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>Smart Learning at Home | Real Parent Feedback on KIPS Online School</b-card-title>
                            <b-card-text> Hear a parent share how KIPS Online School helped her child become more focused, confident, and motivated — all from the comfort of home. </b-card-text>
                          </b-card-body>
                        </div>
                      </SsrCarousel>
                    </b-card>
                  </b-tab>

                  <!-- Testimonials -->
                  <b-tab no-body title="Testimonials">
                    <b-card class="custom-card">
                      <SsrCarousel
                        loop
                        :slides-per-page="4"
                        :autoplay="true"
                        :itemsToScroll="1"
                        :paginate-by-slide="true"
                        :autoplaySpeed="2000"
                        show-dots
                        :responsive="[
                          { maxWidth: 1400, slidesPerPage: 3, itemsToScroll: 1 },
                          { maxWidth: 992, slidesPerPage: 2, itemsToScroll: 1 },
                          { maxWidth: 576, slidesPerPage: 1, itemsToScroll: 1 },
                        ]"
                      >
                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/testimonial-img1.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/qve_u3kRgHw')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>Global Perspective on Smart Education</b-card-title>
                            <b-card-text>Mr. Shaun Covey shares his insights on the importance of smart, structured, and value-driven education — and why KIPS Online School is a powerful step forward in reshaping digital learning in Pakistan. </b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/testimonial-img2.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/abaFjAqZuOE')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>A Global Endorsement for Smarter Learning</b-card-title>
                            <b-card-text> Mr. William McIntyre shares his support for the launch of KIPS Online School, recognizing it as a bold and much-needed step toward accessible, innovative, and quality education in Pakistan. </b-card-text>
                          </b-card-body>
                        </div>

                        <div class="single-thumb">
                          <div class="image-container">
                            <img src="/assets/images/os-images/testimonial-img3.jpeg" alt="Video 1" width="480" height="328" />
                            <div class="play-icon">
                              <img @click="showVideoPopup('https://www.youtube.com/embed/OpAgJrhWULE')" src="/assets/images/os-images/play-icon.png" alt="Video 1" width="60" height="60" />
                            </div>
                          </div>
                          <b-card-body>
                            <b-card-title>A Trusted Step Toward Smarter Learning</b-card-title>
                            <b-card-text>In this powerful testimonial, Dr. Kashif Saleem Sahi. shares his professional insight on the importance of accessible, structured, and high-quality online education — and why KIPS Online School is poised to lead the way.</b-card-text>
                          </b-card-body>
                        </div>
                      </SsrCarousel>
                    </b-card>
                  </b-tab>
                </b-tabs>
              </b-card>
            </div>
          </div>
        </div>
      </section>

      <section id="key-features" class="features section-space">
        <div class="features-bg">
          <div class="container">
            <div class="">
              <div class="headings col-12">
                <h2>Features of KIPS Online School</h2>
              </div>
              <div class="features-div">
                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/global.png" alt="Global Accessibility" width="56" height="56" />
                  </div>
                  <h4>Global Accessibility</h4>
                  <p>Inclusive, worldwide learning with synchronous content, accommodating different time zones for maximum engagement.</p>
                </div>
                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/learning-flex.png" alt="Learning Flexibility" width="56" height="56" />
                  </div>
                  <h4>Learning Flexibility</h4>
                  <p>Adaptable schedules and lesson plans, allowing students to balance academics with personal commitments effectively.</p>
                </div>
                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/unbound-2.png" alt="Unbound Virtual Learning Environment" width="70" height="56" />
                  </div>
                  <h4>Unbound Virtual Learning Environment</h4>
                  <p>Provides unlimited access to high-quality resources, fostering creativity, innovation, and personalized growth.</p>
                </div>
                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/effective.png" alt="Effective Parental Involvement" width="56" height="56" />
                  </div>
                  <h4>Effective Parental Involvement</h4>
                  <p>Encourages parent engagement through reports, feedback, and scheduled meetings for student progress monitoring.</p>
                </div>
                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/home-schooling.png" alt="Complete Model for Home Schooling" width="56" height="56" />
                  </div>
                  <h4>Complete Model for Home Schooling</h4>
                  <p>A full homeschooling solution ensuring academic excellence and comprehensive student development.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/well-designed.png" alt="Well-Designed and Pre-Scheduled Live Classes" width="56" height="56" />
                  </div>
                  <h4>Well-Designed and Pre-Scheduled Live Classes</h4>
                  <p>Structured, engaging sessions planned for interactive learning across global time zones.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/comprehensive.png" alt="Comprehensive Individual Support for Self-Study" width="56" height="56" />
                  </div>
                  <h4>Comprehensive Individual Support for Self-Study</h4>
                  <p>Interactive resources, progress tracking, and feedback enhance independent learning and student success.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/holistic.png" alt="Structured holistic development of students" width="56" height="56" />
                  </div>
                  <h4>Structured holistic development of students</h4>
                  <p>Focuses on moral, intellectual, physical, spiritual, and professional growth through diverse programs.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/per-counselling.png" alt="Individualized Personal Counselling Sessions" width="56" height="56" />
                  </div>
                  <h4>Individualized Personal Counselling Sessions</h4>
                  <p>Personalized academic, emotional, and personal support to ensure student well-being and success.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/pro-tracking.png" alt="rogress Tracking and Timely Feedback Provisions" width="56" height="56" />
                  </div>
                  <h4>Progress Tracking & Timely Feedback Provisions</h4>
                  <p>Continuous student assessment through evaluations, reports, and constructive feedback for improvement.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/personlised-academic.png" alt="Personalized Academic Assignments" width="54" height="54" />
                  </div>
                  <h4>Personalized Academic Assignments</h4>
                  <p>Students will receive personalized academic assignments tailored to their individual learning needs, ensuring both academic excellence and individualized growth.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="featured-programs" class="featured-program section-space">
        <div class="container">
          <div class="">
            <div class="headings col-12">
              <h2><span class="featured-text">Featured</span> Programs Offered</h2>
            </div>

            <div class="featured-program-div" id="exam-boxes-dot">
              <popular-exam />
            </div>

            <div class="text-center">
              <router-link to="/popularPrograms" class="purple-btn btn-margin">Explore More</router-link>
            </div>
          </div>
        </div>
      </section>

      <section id="student-supports" class="student-support last-section-space">
        <div class="ss-bg">
          <div class="container">
            <div class="">
              <div class="headings col-12">
                <h2>Student Support <span class="system-text">System</span></h2>
              </div>
              <div class="ss-boxes">
                <div class="counselling single-box">
                  <div class="img-text">
                    <img src="/assets/images/os-images/counselling.png" alt="" width="56" height="56" />
                    <h4>Counseling & Guidance</h4>
                  </div>
                  <p>Empowering students with personalized counseling and guidance will focus on the following areas:</p>
                  <ul>
                    <li>Academic Excellence</li>
                    <li>Personality Development</li>
                    <li>Career Guidance</li>
                  </ul>
                  <p>This approach fosters academic growth, career readiness, and emotional well-being through expert mentoring and tailored support programs."</p>
                </div>
                <div class="ss-image single-box">
                  <img src="/assets/images/os-images/Student-Support-System.png" alt="" width="480" height="439" />
                </div>
                <div class="technical single-box">
                  <div class="img-text">
                    <img src="/assets/images/os-images/technical.png" alt="" width="56" height="56" />
                    <h4>Technical Support</h4>
                  </div>
                  <p>KIPS Online School provides dedicated technical support to parents and students, ensuring seamless access to learning resources, resolving technical issues, and offering guidance for a smooth online educational experience.</p>
                </div>
              </div>

              <div class="logos-slider">
                <SsrCarousel
                  loop
                  :slides-per-page="5"
                  :autoplay="true"
                  :itemsToScroll="1"
                  :paginate-by-slide="true"
                  :autoplaySpeed="2000"
                  :center-mode="false"
                  show-dots
                  :responsive="[
                    { maxWidth: 1200, slidesPerPage: 3, itemsToScroll: 1 },
                    { maxWidth: 575, slidesPerPage: 1, itemsToScroll: 1 },
                  ]"
                >
                  <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/kips-school-slid.png" alt="" width="188px" height="70px" />
                    </div>
                  </div>

                  <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/kips-college.png" alt="" width="178px" height="70px" />
                    </div>
                  </div>

                  <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/7cs.png" alt="" width="176px" height="70px" />
                    </div>
                  </div>

                  <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/kips-even.png" alt="" width="270px" height="70px" />
                    </div>
                  </div>

                  <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/keys-acdemy.png" alt="" width="176px" height="70px" />
                    </div>
                  </div>

                  <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/os-header-logo.png" alt="" width="148px" height="64px" />
                    </div>
                  </div>

                  <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/qbfn-logoo.png" alt="" width="148px" height="64px" />
                    </div>
                  </div>

                  <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/kips-edu.png" alt="" width="148px" height="64px" />
                    </div>
                  </div>

                  <!-- <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/virtual-logo.png" alt="" width="148px" height="64px" />
                    </div>
                  </div>

                    <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/kipscss.png" alt="" width="148px" height="64px" />
                    </div>
                  </div> -->

                  <div class="slide">
                    <div class="img-logo">
                      <img src="/assets/images/os-images/globalage.png" alt="" width="148px" height="64px" />
                    </div>
                  </div>
                </SsrCarousel>
              </div>
            </div>
          </div>
        </div>
      </section>
      <b-modal size="lg" centered id="aboutUsvideoModal" title="" hide-footer hide-header content-class="p-0">
        <div v-if="videoLink" class="video-container">
          <iframe :src="videoLink" class="responsive-iframe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
        </div>
      </b-modal>
      <b-modal scrollable centered text id="bannerPopup" title="" size="xl" hide-footer hide-header-close>
        <span variant="link" class="close-btn" @click="$bvModal.hide('bannerPopup')"> &times; </span>
        <div v-if="programCategories[0] && programCategories[0].PopupBanner && programCategories[0].PopupBanner.RedirectPath" @click="navigateToPath(programCategories[0].PopupBanner.RedirectPath)" style="cursor: pointer">
          <img v-if="programCategories[0].PopupBanner.Image" :src="programCategories[0].PopupBanner.Image" style="min-height: 300px" alt="" />
        </div>
        <div v-else>
          <img v-if="programCategories[0] && programCategories[0].PopupBanner && programCategories[0].PopupBanner.Image" :src="programCategories[0].PopupBanner.Image" style="min-height: 300px" alt="" />
        </div>
      </b-modal>
      <!-- 
      <section class="site-footer">
        <div class="site-footer-upper">
          <div class="container">
            <div class="row">
              <div class="footer-body">
                <div class="col-sm-12 col-lg-4 logo-div">
                  <div class="footer-logo">
                    <img
                      src="/assets/images/os-images/footer-logo.png"
                      alt=""
                      width="346"
                      height="75"
                    />
                  </div>
                  <p>
                    KIPS Online School delivers quality education, fostering global
                    success through flexibility and inclusivity.
                  </p>
                </div>
                <div class="col-sm-12 col-lg-4 usefull-links">
                  <span>Usefull Links</span>
                  <ul>
                    <li><a href="">Our Programs</a></li>
                    <li><a href="">Registration</a></li>
                    <li><a href="">Activities</a></li>
                    <li><a href="">Student Portal</a></li>
                    <li><a href="">Contact Us</a></li>
                    <li><a href="">FAQs</a></li>
                  </ul>
                </div>
                <div class="col-sm-12 col-lg-4 newsletter">
                  <span>Newsletter</span>
                  <div class="email-btn">
                    <span class="email-icon"
                      ><img
                        src="/assets/images/os-images/envelop.png"
                        alt="envelop"
                        width="28"
                        height="20"
                    /></span>
                    <input type="email" placeholder="Enter your email id" />
                    <button class="arrow-btn">→</button>
                  </div>
                  <div class="social-icons">
                    <ul>
                      <li>
                        <a href="">
                          <svg
                            width="12"
                            height="22"
                            viewBox="0 0 12 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.499 0.00457742L8.64615 0C5.44104 0 3.36976 2.12507 3.36976 5.41417V7.91047H0.501322C0.442393 7.91047 0.384042 7.92208 0.329602 7.94464C0.275162 7.9672 0.2257 8.00026 0.184042 8.04194C0.142383 8.08362 0.109345 8.1331 0.0868153 8.18755C0.0642851 8.242 0.0527044 8.30036 0.0527344 8.35928V11.9761C0.0527344 12.0951 0.0999964 12.2092 0.184123 12.2933C0.268249 12.3775 0.382349 12.4247 0.501322 12.4247H3.36976V21.5512C3.36976 21.6702 3.41702 21.7843 3.50115 21.8684C3.58528 21.9525 3.69938 21.9998 3.81835 21.9998H7.56085C7.67982 21.9998 7.79392 21.9525 7.87805 21.8684C7.96217 21.7843 8.00944 21.6702 8.00944 21.5512V12.4247H11.3633C11.4823 12.4247 11.5964 12.3775 11.6805 12.2933C11.7646 12.2092 11.8119 12.0951 11.8119 11.9761L11.8133 8.35928C11.8132 8.24029 11.7658 8.1262 11.6817 8.04206C11.5975 7.95791 11.4835 7.91059 11.3645 7.91047H8.00944V5.79433C8.00944 4.77722 8.25181 4.26089 9.57674 4.26089L11.4986 4.26021C11.6175 4.26014 11.7315 4.21286 11.8156 4.12874C11.8997 4.04462 11.9469 3.93055 11.9469 3.81162V0.453165C11.9469 0.334311 11.8998 0.220315 11.8158 0.136208C11.7318 0.0521014 11.6179 0.00475934 11.499 0.00457742Z"
                              fill="#0089D0"
                            />
                          </svg>
                        </a>
                      </li>

                      <li>
                        <a href="">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 6.33203C7.97603 6.33203 6.33203 7.97603 6.33203 10C6.33203 12.024 7.97603 13.672 10 13.672C12.024 13.672 13.672 12.024 13.672 10C13.672 7.97603 12.024 6.33203 10 6.33203Z"
                              fill="#0089D0"
                            />
                            <path
                              d="M15.536 0H4.464C2.004 0 0 2.004 0 4.464V15.536C0 18 2.004 20 4.464 20H15.536C18 20 20 18 20 15.536V4.464C20 2.004 18 0 15.536 0ZM10 16.48C6.428 16.48 3.52 13.572 3.52 10C3.52 6.428 6.428 3.524 10 3.524C13.572 3.524 16.48 6.428 16.48 10C16.48 13.572 13.572 16.48 10 16.48ZM16.616 4.7C15.86 4.7 15.244 4.088 15.244 3.332C15.244 2.576 15.86 1.96 16.616 1.96C17.372 1.96 17.988 2.576 17.988 3.332C17.988 4.088 17.372 4.7 16.616 4.7Z"
                              fill="#0089D0"
                            />
                          </svg>
                        </a>
                      </li>

                      <li>
                        <a href="">
                          <svg
                            width="24"
                            height="18"
                            viewBox="0 0 24 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M23.0645 2.0046C22.1982 0.974765 20.5987 0.554688 17.5441 0.554688H6.45569C3.33112 0.554688 1.70454 1.00186 0.841471 2.09827C0 3.16728 0 4.74238 0 6.92235V11.0774C0 15.3007 0.9984 17.445 6.45569 17.445H17.5442C20.1931 17.445 21.661 17.0743 22.6106 16.1654C23.5845 15.2335 24 13.7118 24 11.0774V6.92235C24 4.62338 23.9349 3.039 23.0645 2.0046ZM15.4081 9.5735L10.3729 12.2051C10.2549 12.2668 10.123 12.2971 9.98985 12.2929C9.85674 12.2887 9.72696 12.2503 9.61306 12.1813C9.49915 12.1123 9.40497 12.0151 9.33963 11.899C9.2743 11.783 9.24001 11.6521 9.24008 11.5189V6.27265C9.24008 6.13968 9.27434 6.00895 9.33954 5.89306C9.40474 5.77718 9.49869 5.68004 9.61234 5.611C9.72599 5.54197 9.8555 5.50337 9.98839 5.49893C10.1213 5.49448 10.2531 5.52434 10.3711 5.58563L15.4063 8.20024C15.532 8.26549 15.6373 8.36395 15.7109 8.48492C15.7845 8.60589 15.8236 8.74473 15.8237 8.88633C15.8239 9.02793 15.7853 9.16687 15.712 9.28802C15.6387 9.40918 15.5336 9.50792 15.4081 9.5735Z"
                              fill="#0089D0"
                            />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="site-footer-bottom">
          <div class="container">
            <div class="row">
              <div class="copy-terms">
                <span>Copyright © 2024 KIPS Online School - All Rights Reserved.</span>
                <span>Term and Condition - Privacy Policy</span>
              </div>
            </div>
          </div>
        </div>
      </section> -->
    </div>
  </div>
</template>

<script>
import SsrCarousel from "vue-ssr-carousel";
import ssrCarouselCss from "vue-ssr-carousel/index.css";
import popularExam from "./popularExams";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import axios from "axios";
import cryptojs from "../plugins/crypto";
import { mapGetters, mapActions } from "vuex";
import { programCategories as programCategoriesStoreKeys } from "../store/keys";

export default {
  metaInfo() {
    return {
      title: "KIPS ONLINE SCHOOL",
      titleTemplate: "",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  components: {
    SsrCarousel,
    popularExam,
    VueSlickCarousel,
  },
  mounted() {
    // const script = document.createElement("script");
    // script.setAttribute("src", "https://assets.calendly.com/assets/external/widget.js");
    // document.head.appendChild(script);
    this.getJsonCategories();
    this.getProgramCategories();
    this.$nextTick(() => {
      this.contentSettings.asNavFor = this.$refs.activityImg;
      this.thumbnailSettings.asNavFor = this.$refs.activityContent;
    });
  },
  data() {
    return {
      activities: [
        {
          title: "Motivational Mondays",
          description: "Weekly inspiring guest sessions fostering resilience, creativity, leadership, and goal-setting skills.",
          imgSrc: "/assets/images/os-images/activity-1.png",
        },
        {
          title: "Celebration Hour",
          description: "Fun sessions recognizing achievements with creative activities, talent showcases, and virtual events.",
          imgSrc: "/assets/images/os-images/cel-hours.png",
        },
        {
          title: "Global Connect",
          description: "Virtual tours, language lessons, and pen-pal programs promoting cultural awareness and global  appreciation.",
          imgSrc: "/assets/images/os-images/global-con.png",
        },
        {
          title: "Project Presentations",
          description: "Students showcase research, creativity, and teamwork through engaging, well-structured virtual  presentations.",
          imgSrc: "/assets/images/os-images/proj-pre.png",
        },
        {
          title: "School Assembly",
          description: " Inclusive virtual gatherings fostering community, shared learning, collaboration, and reinforcing school  values.",
          imgSrc: "/assets/images/os-images/sch-ass.png",
        },
        {
          title: "Mindfulness Moments",
          description: "Teacher-led yoga and mindfulness exercises enhancing focus, emotional well-being, and physical  health.",
          imgSrc: "/assets/images/os-images/mind-mom.png",
        },
        {
          title: "Health Talk",
          description: "Tracks student fitness, promotes well-being, and encourages healthy habits through personalized  recommendations.",
          imgSrc: "/assets/images/os-images/health-talk.png",
        },
        {
          title: "Virtual Tours",
          description: "Interactive online classes that engage students and enhance their digital learning experience dynamically.",
          imgSrc: "/assets/images/os-images/vir-tour.png",
        },
      ],
      contentSettings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        asNavFor: null, // Will be set in mounted()
      },
      thumbnailSettings: {
        slidesToShow: 8,
        slidesToScroll: 1,
        dots: false,
        autoplay: true,
        focusOnSelect: true,
        arrows: false,
        asNavFor: null, // Will be set in mounted()
        centerMode: true, // ✅ Default for large screens
        speed: 500, // Add explicit speed
        autoplaySpeed: 2000, // Make sure this matches your desired speed
        pauseOnHover: true, // Add this to prevent speed issues on hover
        waitForAnimate: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
              centerMode: false, // 👈 Override below 992
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              centerMode: false,
            },
          },
        ],
      },
      settings: {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              dots: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              dots: false,
            },
          },
          {
            breakpoint: 600, // Added this breakpoint
            settings: {
              slidesToShow: 1,
              dots: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              dots: false,
            },
          },
        ],
      },
      categoriesData: null,
      videoLink: "",
    };
  },
  asyncData({ store, route }) {
    return Promise.resolve();
  },
  computed: {
    ...mapGetters(programCategoriesStoreKeys.namespace, programCategoriesStoreKeys.getters),
  },
  methods: {
    ...mapActions(programCategoriesStoreKeys.namespace, programCategoriesStoreKeys.actions),
    async getProgramCategories() {
      await this.get_ProgramCategories({
        config: {
          loader: {
            show: true,
            id: "boardLoader",
          },
        },
      });
      if (this.programCategories[0] && this.programCategories[0].PopupBanner && this.programCategories[0].PopupBanner.Image) {
        this.$bvModal.show("bannerPopup");
      }
    },
    async getJsonCategories() {
      const baseUrl = process.env.VUE_APP_URL;
      try {
        const response = await axios.get(`${baseUrl}/assets/categories/index.json`);
        this.categoriesData = response.data;
        this.get_categoriesFromJson({
          data: {
            categories: response.data,
          },
        });
      } catch (error) {}
    },
    goToCategoryDetail(item) {
      this.$router.push({
        path: `${item.link}/${cryptojs.UTF.encrypt(item.programCategoryId)}/${this.getRouteName(item.routeName)}`,
      });
    },
    openBookDemoPopup() {
      Calendly.initPopupWidget({
        url: "https://calendly.com/kipsonlineschool/book-a-demo",
      });
      return false;
    },
    showVideoPopup(link) {
      this.videoLink = link;
      this.$bvModal.show("aboutUsvideoModal");
    },
  },
};
</script>
<style scoped>
:v-deep #aboutUsvideoModal .modal-content {
  background-color: black;
}

::v-deep #aboutUsvideoModal .modal-body {
  padding: 0 !important;
}

.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

/* Add media query for larger screens */
@media (min-width: 992px) {
  ::v-deep #aboutUsvideoModal .modal-content {
    background-color: black;
  }

  .video-container {
    width: 152%;
    height: 80vh;
    /* This will take 80% of viewport height */
  }

  .responsive-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  color: #ffffff;
  opacity: 0.7;
  cursor: pointer;
}

.close-btn:hover {
  opacity: 1;
}
</style>
